// extracted by css-extract-rspack-plugin
export default {"page_toggles":"MNdJF","pageToggles":"MNdJF","disabled_override":"riw9D","disabledOverride":"riw9D","#":"gpYjt","ellipsis":"Qy9Wf"};